import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SidebarCustom from '../../common/Layout/Sidebar';
import HouseIcon from 'apollo-react-icons/House';
import PresentationHierarchyLight from 'apollo-react-icons/PresentationHierarchyLight';
import ChevronLeft2 from 'apollo-react-icons/ChevronLeft2';
import CardView from 'apollo-react-icons/CardView';
import Services from 'apollo-react-icons/Services';
import Hotel from 'apollo-react-icons/Hotel';
import { getCurrentUser, logout } from '../services/authService';
import { CATEGORIES } from '../../../constants/categories';
// import { useAuth } from '../../../Contexts/Auth';

const Sidebar = (props) => {
  const navigate = useNavigate();
  // const {isAuthenticated}= useAuth()
  const [profileMenuProps, setProfileMenuProps] = React.useState([]);
  const { t } = useTranslation();

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        const response = await getCurrentUser();
        if (!response) return;
        setProfileMenuProps(response);
      } catch (error) {
        console.error("Error fetching profile data:", error);
      }
    };

    fetchProfileData();
  }, []);

  const checkUserCategory = (category) => {
    return profileMenuProps.end_users_category?.name === category;
  };

  let menuItems = [
    {
      text: t('dashboard'),
      icon: HouseIcon,
      handleOnClick: () => {
        navigate('/customer/home');
      },
      pathname: '/customer/home',
    },
    ...checkUserCategory(CATEGORIES.APPLICANT) ? [{
      text: t('Requests'),
      // handleOnClick: () => {
      //   navigate('/customer/workflows');
      // },
      icon: PresentationHierarchyLight,
      // pathname: '/customer/workflows',
      menuItems: [
        {
          text: t('My_Requests'),
          handleOnClick: () => {
            navigate('/customer/requests/my-requests');
          },
          pathname: '/customer/requests/my-requests',
          parentName: t('Requests'), // Custom tag to identify parent
        },
        {
          text: t('New_Requests'),
          handleOnClick: () => {
            navigate('/customer/requests/new-requests');
          },
          pathname: '/customer/requests/new-requests',
          parentName: t('Requests'), // Custom tag to identify parent
        },
      ]
    }] : [],
    ...(CATEGORIES.COMMITTEE_CATEGORIES.some(category => checkUserCategory(category))) ? [{
      text: t("Assessment Reviews"),
      icon: PresentationHierarchyLight,
      handleOnClick: () => {
        navigate('/customer/assessment-review');
      },
      pathname: '/customer/assessment-review',
    }] : [],
        {
      text: t('Product Details'),
      icon: CardView,
      handleOnClick: () => {
        navigate('/customer/product-details');
      },
      pathname: '/customer/product-details',
    },
    {
      text: t('Manufacturers Site'),
      icon: Hotel,
      handleOnClick: () => {
        navigate('/customer/manufacturers-site');
      },
      pathname: '/customer/manufacturers-site',
    },
    {
      text: t('Services'),
      icon: Services,
      handleOnClick: () => {},
      pathname: '',
    },
    {
      text: t('sign_out'),
      icon: ChevronLeft2,
      href: '/login',
      handleOnClick: () => { logout(); navigate('/login'); },
    },

  ];

  return (
    <SidebarCustom
      isSidebarCollapsed={props.isSidebarCollapsed}
      setIsSidebarCollapsed={props.setIsSidebarCollapsed}
      menuItems={menuItems}
    />
  );
}

export default Sidebar;